export const environment = {
  ENV: 'dev',
  SAPPHIRE_API_URL: 'https://dev.api.irisgst.com/irisgst/sapphire/',
  SAPPHIRE_MGMT_API_URL: 'https://dev.api.irisgst.com/irisgst/mgmt/',
  UUM_LOGOUT_URL: 'https://gstsuite.dev.sovos.com/auth/logout-all-session',
  SAPPHIRE1_WEB_URL: 'https://gstcompliance-gstsuite.dev.sovos.com/',
  TENANT: 'dev',
  APP_NAME: 'SOVOS',
  GTAD_MEASUREMENT_ID: '',
  FP_GSTR1: '042024',
  FP_GSTR1A: '072024',
  LOGO_URL: 'assets/logos/sovos.full.png',
  TITLE: 'SOVOS-GST',
  FAVICON_URL: 'assets/favicon.ico',
  GSTR6_ENABLED: true,
  RECON_ENABLED: true,
};
// export const environment = {
//   ENV: 'staging',
//   SAPPHIRE_API_URL: 'https://api.manualrecon.irisgst.com/irisgst/sapphire/',
//   SAPPHIRE_MGMT_API_URL: 'https://api.manualrecon.irisgst.com/irisgst/mgmt/',
//   SAPPHIRE1_WEB_URL: 'https://gstcompliance-gstsuite.stage.sovos.com/',
//   TENANT: 'asp',
//   APP_NAME: 'SOVOS',
//   GTAD_MEASUREMENT_ID: 'G-C3FS357YRC',
//   FP_GSTR1: '052025',
//   FP_GSTR1A: '052025',
//   LOGO_URL: 'assets/logos/sovos.full.png',
//   TITLE: 'SOVOS-GST',
//   FAVICON_URL: 'assets/favicon.ico',
//   GSTR6_ENABLED: true,
//   RECON_ENABLED: true,
// };

// export const environment = {
//   ENV: 'prod',
//   SAPPHIRE_API_URL: 'https://api.irisgst.com/irisgst/sapphire/',
//   SAPPHIRE_MGMT_API_URL: 'https://api.irisgst.com/irisgst/mgmt/',
//   SAPPHIRE1_WEB_URL: 'https://gstcompliance-gstsuite.sovos.com/',
//   TENANT: 'asp',
//   APP_NAME: 'SOVOS',
//   GTAD_MEASUREMENT_ID: 'G-3NDWZF6WF4',
//   FP_GSTR1: '052025',
//   FP_GSTR1A: '052025',
//   LOGO_URL: 'assets/logos/sovos.full.png',
//   TITLE: 'SOVOS-GST',
//   FAVICON_URL: 'assets/favicon.ico',
//    GSTR6_ENABLED: false,
//   RECON_ENABLED: false,
// };
